<h2 mat-dialog-title class="cart-header">
    <span class="title-large">Carrello</span>

    <button
        mat-icon-button
        type="button"
        aria-label="Chiudi carrello"
        (click)="onClose()"
    >
        <i class="fa-regular fa-xmark"></i>
    </button>
</h2>

<mat-dialog-content class="cart-content">
    @if (rows().length === 0) {
        <div class="cart-empty">
            <span class="body-medium">Il carrello è vuoto.</span>
        </div>
    } @else {
        @for (row of rows(); track row.id) {
            <div class="cart-row">
                <div class="cart-row-header">
                    <div class="cart-row-product">
                        <span class="body-medium emphasized cart-row-name">{{ row.nomeProdotto }}</span>
                        <span class="body-small">{{ row.nomeImballo ?? '-' }} - {{ row.unitaFatturabile }} {{ row.unitaMisura }}</span>
                    </div>

                    <div class="quantity-stepper">
                        <button
                            matButton="tonal"
                            aria-label="Rimuovi riga"
                            class="stepper-button"
                            (click)="remove(row)"
                        >
                            <i class="fa-regular fa-trash-can"></i>
                        </button>

                        @if (row.quantita > 1) {
                            <button
                                matButton="tonal"
                                aria-label="Diminuisci quantità"
                                class="stepper-button"
                                (click)="decrement(row)"
                            >
                                <i class="fa-regular fa-minus"></i>
                            </button>
                        }

                        <span class="body-medium emphasized quantity-value">{{ row.quantita }}</span>

                        <button
                            matButton="tonal"
                            aria-label="Aumenta quantità"
                            class="stepper-button"
                            (click)="increment(row)"
                        >
                            <i class="fa-regular fa-plus"></i>
                        </button>
                    </div>
                </div>

                <div class="cart-row-detail">
                    <span class="body-medium cart-row-label">Prezzo unitario</span>
                    <span class="body-medium cart-row-value">
                        {{ row.prezzo | translocoCurrency: 'symbol' : { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}/{{ row.unitaMisura }}
                        <button mat-icon-button type="button" aria-label="Modifica prezzo" class="edit-price-button" (click)="editPrice(row)">
                            <i class="fa-regular fa-pen"></i>
                        </button>
                    </span>
                </div>

                <div class="cart-row-detail">
                    <span class="body-medium cart-row-label">Subtotale</span>
                    <span class="body-medium cart-row-value">
                        {{ row.imponibile | translocoCurrency: 'symbol' : { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
                    </span>
                </div>

                @if (row.provvigioneDisponibile) {
                    <div class="cart-row-detail">
                        <span class="body-medium cart-row-label">Provvigione agente</span>
                        <span class="body-medium cart-row-value">{{ row.percProvvigione }}%</span>
                    </div>

                    <div class="cart-row-detail">
                        <span class="body-medium cart-row-label">Importo</span>
                        <span class="body-medium cart-row-value">
                            {{ row.provvigione | translocoCurrency: 'symbol' : { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
                        </span>
                    </div>
                }
            </div>

            <mat-divider></mat-divider>
        }
    }
</mat-dialog-content>

@if (rows().length > 0) {
    <div class="cart-summary">
        <div class="cart-summary-row">
            <span class="body-medium emphasized">Subtotale</span>
            <span class="body-medium emphasized">
                {{ cart()?.totaleImponibile ?? 0 | translocoCurrency: 'symbol' : { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
            </span>
        </div>

        <div class="cart-summary-row">
            <span class="body-small">CONOU</span>
            <span class="body-small">
                {{ cart()?.totaleConou ?? 0 | translocoCurrency: 'symbol' : { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
            </span>
        </div>

        <div class="cart-summary-row">
            <span class="title-large">TOTALE</span>
            <span class="title-large">
                @if (cart()?.totale != null) {
                    {{ cart()?.totale | translocoCurrency: 'symbol' : { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
                } @else {
                    -
                }
            </span>
        </div>

        <div class="cart-summary-row">
            <span class="body-small">Tot. provvigioni agente</span>
            <span class="body-small">
                {{ cart()?.totaleProvvigione ?? 0 | translocoCurrency: 'symbol' : { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
            </span>
        </div>

        <div class="cart-summary-actions">
            <button matButton="outlined" type="button" (click)="clearCart()">Svuota carrello</button>
            <button matButton="filled" type="button">Vai a proposta</button>
        </div>
    </div>
}
